import { CustomError } from './CustomError';

export class TwitchConfigurationServiceError extends CustomError {
	description =
		'There was a problem loading configuration from Twitch Configuration Service';

	name = 'TwitchConfigurationServiceError';
}
